export default __webpack_public_path__ + "d0ae2242a5cace8734a1e89a1c39d214.png";